import { useEffect } from 'react'
import { useMap } from 'react-leaflet'

export const useDrawUndo = (resetDrawMode: () => void) => {
    const map = useMap()

    useEffect(() => {
        const handleUndo = (e: KeyboardEvent | MouseEvent) => {
            if ((e instanceof KeyboardEvent && e.key === 'Backspace') || (e instanceof MouseEvent && e.button === 2)) {
                const activeShape = map.pm.Draw.getActiveShape()
                if (!activeShape) return

                const drawer = map.pm.Draw[activeShape] as unknown & {
                    _removeLastVertex?: () => void
                    _markers?: any[]
                }
                if (drawer?._removeLastVertex) {
                    e.preventDefault()
                    if (drawer._markers?.length > 1) {
                        drawer._removeLastVertex()
                    } else {
                        resetDrawMode()
                    }
                }
            }
        }

        const handleCancel = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                resetDrawMode()
            }
        }

        document.addEventListener('keydown', handleUndo)
        document.addEventListener('keydown', handleCancel)
        document.addEventListener('contextmenu', handleUndo)
        return () => {
            document.removeEventListener('keydown', handleUndo)
            document.removeEventListener('keydown', handleCancel)
            document.removeEventListener('contextmenu', handleUndo)
        }
    }, [map])
}
